import React from "react";
import styles from "./PaymentPlanCard.module.scss";
import { useNavigate } from "react-router-dom";
import { API } from "service/Interceptor";
import { callBack, subscriptionInitiate } from "service/apiUrl";
import { useDispatch, useSelector } from "react-redux";
import { initiateSubscription } from "reducer/paymentSlice";
import toast from "components/Toast/toast";
import { combineClasses } from "utils/utils";
import { isWithin7DaysOfEnd } from "utils/constants";

const PaymentPlanCard = ({
  cardname = "",
  planId = "",
  description = "",
  currPrice = "",
  duration = 0,
  taxPercent = 0,
  taxAmount = 0,
  totalAmount = 0,
  setTimeLeft,
}) => {
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const { activePlan } = useSelector((state) => state.payment);

  const ANNUAL_PLAN = "Annual Plan";
  const MONTHLY_PLAN = "Monthly Plan";

  //Start Free Trial for new user and initiate Payment for already on Trial period.
  const startSubscription = async (id) => {
    const payload = {
      planId: id,
      userFreeTrial: true,
    };
    try {
      const res = await dispatch(initiateSubscription(payload));
      if (res?.data?.message) {
        toast.error(res?.data?.message);
        return;
      }
      const orderId = res?.payload?.paymentOrderId;
      const keyId = res?.payload?.paymentKeyId;

      if (orderId) {
        toast.success(
          res?.payload?.message || "Free Trial Activated Successfully"
        );
        return { orderId, keyId };
      }
      setTimeLeft(3);
    } catch (error) {
      console.log(error);
    }
  };

  //Payment Gateway of Razorpay to call if user has already started 15 days free trial and not when user hasn,t taken any trial period.
  const loadRazorpay = (orderId, keyId, amount, description) => {
    const options = {
      // key: "rzp_test_tganW05fMuX1O2", //Razorpay key of Sahej
      key: keyId,
      order_id: orderId,
      currency: "INR",
      name: "Qreativs",
      image: "/assets/svg/Frame 1000004554.svg",

      callback_url: callBack,
      theme: {
        color: "#3399cc",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  const handleSubscription = async (id, amount, desc) => {
    const data = await startSubscription(id);

    if (!data) return;
    const { orderId = "", keyId = "" } = data || {};
    if (orderId) {
      loadRazorpay(orderId, keyId, amount, desc);
    }
  };

  // const isDisabled = () => {
  //   if (!activePlan || activePlan?.status !== "ACTIVE") return false;

  //   const isExpiring = isWithin7DaysOfEnd(activePlan?.endDate);
  //   console.log("isExpiring is", isExpiring);

  //   // if (
  //   //   activePlan?.name === ANNUAL_PLAN ||
  //   //   activePlan?.queuedSubscription?.name === ANNUAL_PLAN
  //   // ) {
  //   //   return true;
  //   // }

  //   if (activePlan?.name === ANNUAL_PLAN) {
  //     //if plan is annual, going to expire, no queued plan
  //     if (isExpiring && !activePlan?.queuedSubscription) {
  //       return false; //enabled
  //     }

  //     //plan is annual, going to expire , have queued plan
  //     if (!isExpiring && activePlan?.queuedSubscription) {
  //       return true; //disabled
  //     }

  //     return true; // Default fallback for other annual cases
  //   }

  //   //Monthly check
  //   // if (activePlan?.name === MONTHLY_PLAN) {
  //   //   return cardname === MONTHLY_PLAN && isExpiring;
  //   // }

  //   if (activePlan?.name === MONTHLY_PLAN) {
  //     if (isExpiring) {
  //       if (!activePlan?.queuedSubscription) {
  //         return false;
  //       }
  //       return true;
  //     }

  //     return true; // If not expiring, allow
  //   }

  //   // return false;
  // };


  // const getButtonLabel = () => {
  //   const isExpiring = isWithin7DaysOfEnd(activePlan?.endDate);
  //   if (!activePlan || activePlan?.status !== "ACTIVE") {
  //     return !activePlan?.freeTrial ? "Start your free trial" : "Pay Now";
  //   }

  //   // if (
  //   //   activePlan?.name === ANNUAL_PLAN ||
  //   //   activePlan?.queuedSubscription?.name === ANNUAL_PLAN
  //   // ) {
  //   //   return "Subscribed";
  //   // }

  //   //Annual Plan
  //   if (activePlan?.name === ANNUAL_PLAN) {
  //     if (isExpiring && !activePlan?.queuedSubscription) {
  //       return "Pay Now";
  //     }
  //     return "Subscribed";
  //   }

  //   //Monthly case handling
  //   if (activePlan?.name === MONTHLY_PLAN) {
  //     if (isExpiring) {
  //       if (!activePlan?.queuedSubscription) {
  //         return "Pay Now";
  //       }
  //       return "Subscribed";
  //     }
  //     return "Subscribed";
  //   }

  //   // if (activePlan?.name === MONTHLY_PLAN) {
  //   //   return cardname === MONTHLY_PLAN ? isExpiring && "Pay Now" : "Subscribed";
  //   // }

  //   // return "Pay Now";
  // };



  const isDisabled = (buttonType) => {
    if (!activePlan || activePlan.status !== "ACTIVE") return false;

    const isExpiring = isWithin7DaysOfEnd(activePlan.endDate);
    const hasQueuedAnnual = activePlan?.queuedSubscription?.name === ANNUAL_PLAN;

    if (hasQueuedAnnual) return true;

    const isAnnual = activePlan.name === ANNUAL_PLAN;
    const isMonthly = activePlan.name === MONTHLY_PLAN;

    if (isAnnual) {
      return !isExpiring;
    }

    if (isMonthly) {
      if (buttonType === MONTHLY_PLAN) {
        return !isExpiring;
      }
      if (buttonType === ANNUAL_PLAN) {
        return false;
      }
    }

    return false;
  };

  const getButtonLabel = (planType) => {
    if (!activePlan || activePlan.status !== "ACTIVE") {
      return activePlan?.freeTrial ? "Pay Now" : "Start your free trial";
    }

    const isExpiring = isWithin7DaysOfEnd(activePlan.endDate);
    const hasQueuedAnnual = activePlan?.queuedSubscription?.name === ANNUAL_PLAN;

    if (hasQueuedAnnual || activePlan?.name === ANNUAL_PLAN) {
      return "Subscribed";
    }

    const isSameAsActive = activePlan.name === planType;
    const hasQueuedPlan = !!activePlan?.queuedSubscription;

    if (isSameAsActive) {
      if (isExpiring && !hasQueuedPlan) {
        return "Pay Now";
      }
      return "Subscribed";
    }

    return "Pay Now";
  };


  return (
    <div
      className={
        activePlan?.planId === planId
          ? combineClasses(styles.planCards, styles.highlight)
          : styles.planCards
      }
    >
      {activePlan?.planId === planId && (
        <span className={styles.activeCard}>My plan</span>
      )}

      <div>
        <div className={styles.cardHeader}>
          <p>{cardname}</p>
        </div>
        <p className={styles.description}>{description}</p>
        <div className={styles.pricing}>
          <p>{`Duration : ${duration} ${duration > 1 ? "months" : "month"}`}</p>
          <p>
            <span>₹{currPrice}</span>
            {cardname === "Annual Plan" ? "/year" : "/month"}
          </p>
        </div>
        {taxPercent > 0 && (
          <div className={styles.tax_section}>
            <p>
              Total Tax <span>{taxPercent}%</span>
            </p>
            <p>
              Tax Amount <span>{taxAmount}</span>
            </p>
            <p>
              Total Amount to pay<span>{totalAmount}</span>
            </p>
          </div>
        )}
      </div>

      <div className={styles.featuresButton}>
        {/* Toggle the button on the basis of flag received from the activeplan API */}
        <p>
          Terms & Conditions <br /> Subscription cannot be cancelled once done.
        </p>
        <button
          onClick={() => handleSubscription(planId, currPrice, description)}
          disabled={isDisabled(cardname)}
        >
          {getButtonLabel(cardname)}
        </button>
      </div>
    </div>
  );
};

export default PaymentPlanCard;
